import { z } from 'zod'

import type {
  Note,
  NoteInitializer,
  NoteMutator,
} from '../schemas/public/Note.js'
import { noteInitializer } from '../schemas/public/Note.js'
import type { NotificationId } from '../schemas/public/Notification.js'

export type ExtendedNotificationNoteInitializer = NoteInitializer & {
  notificationId: NotificationId
}

export type ExtendedNotificationNoteMutator = NoteMutator & {
  notificationId: NotificationId
}

export type ExtendedNotificationNote = Note & {
  notificationId: NotificationId
}

export const notificationFields = z.object({
  notificationId: z.string().uuid(),
})

export const extendedNotificationNoteInitializer = z.object({
  ...notificationFields.shape,
  ...(noteInitializer as unknown as z.ZodObject<any>).shape,
}) as unknown as z.Schema<ExtendedNotificationNoteInitializer>

export const extendedNotificationNoteMutator = z.object({
  ...notificationFields.shape,
  ...(noteInitializer as unknown as z.ZodObject<any>).shape,
}) as unknown as z.Schema<ExtendedNotificationNoteMutator>

export const extendedNotificationNote = z.object({
  ...notificationFields.shape,
  ...(noteInitializer as unknown as z.ZodObject<any>).shape,
}) as unknown as z.Schema<ExtendedNotificationNote>
